
// Position each gift step within the visible screen, below the sticky menu.
function cbfCenterGift(node, smooth = true) {
  clearTimeout(cbfCenterGift.timer);
  cbfCenterGift.observer?.disconnect();
  const started = Date.now();
  const position = () => {
    const target = node?.matches('.alpha-widget, .alpha-cartPage-page')
      ? node.querySelector('.alpha-free-gift-widget') || node : node;
    if (!target?.isConnected) return;
    const rect = target.getBoundingClientRect();
    if (!rect.height || document.documentElement.dataset.cbfHueEligible === 'false') {
      if (Date.now() - started < 6000) cbfCenterGift.timer = setTimeout(position, 100);
      return;
    }
    const viewport = window.visualViewport;
    const height = viewport?.height || window.innerHeight;
    const offset = viewport?.offsetTop || 0;
    const header = document.querySelector('sticky-header');
    const top = offset + Math.min(header?.getBoundingClientRect().height || 0, height / 3) + 16;
    const bottom = 56;
    const available = Math.max(100, height - top - bottom);
    const desired = top + Math.max(0, (available - rect.height) / 2);
    window.scrollTo({
      top: Math.max(0, window.scrollY + rect.top - desired),
      behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
    });
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll:true});
  };
  // Let the app finish replacing and measuring the current gift step.
  cbfCenterGift.timer = setTimeout(position, 250);
}

(() => {
  const start = () => {
    const main = document.querySelector('main');
    if (!main || !document.querySelector('#cbf-cart-benefits')) return;
    let queued = false;
    const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
    const refresh = () => {
      queued = false;
      const panel = document.querySelector('#cbf-cart-benefits .cbfa-gift');
      if (!panel) return;
      const container = document.querySelector('cart-items > .page-width');
      if (!container) return;
      container.classList.add('cbf-branded-cart');
      const benefits = document.getElementById('cbf-cart-benefits');
      if (benefits.parentElement !== container) container.prepend(benefits);
      let range = panel.querySelector('.cbf-hue-range');
      if (!range) { range = document.createElement('p'); range.className = 'cbf-hue-range'; panel.append(range); }
      const intro = document.querySelector('#cbf-gift-selector [data-gift-intro]');
      text(range, intro?.textContent || '');
      const widgets = [...container.querySelectorAll('.alpha-widget')].filter(n => n.querySelector('.alpha-cartPage-page'));
      widgets.forEach(root => {
        const i = root.classList.contains('alpha-6ab6f343cb8b7624e2db31b4') ? 1 : 0;
        const widget = root.querySelector('.alpha-free-gift-widget');
        const claimed = !!widget.querySelector('.alpha-free-gift-card__btn.is-claimed');
        text(widget.querySelector('.alpha-free-gift-widget__title'), root.dataset.cbfStepTitle || (claimed ? (i ? 'Votre deuxième gramme est ajouté ✓' : 'Votre gramme offert est ajouté ✓') : (i ? 'Choisissez votre deuxième gramme offert' : 'Choisissez votre gramme offert')));
        widget.querySelectorAll('.alpha-free-gift-card__free-text').forEach(n => text(n, '1 g OFFERT'));
        widget.querySelectorAll('.alpha-free-gift-card__btn').forEach(n => {
          const label = n.classList.contains('is-claimed') ? 'Sélectionné ✓' : n.disabled ? 'Indisponible' : 'Choisir';
          if(n.getAttribute('aria-label') !== label) n.setAttribute('aria-label',label);
          if(n.dataset.cbfLabel !== label) n.dataset.cbfLabel = label;
        });
        widget.querySelectorAll('.alpha-free-gift-card__variant-select').forEach(n => {
          if (!n.hasAttribute('aria-label')) n.setAttribute('aria-label', 'Quantité du cadeau');
        });
        widget.querySelectorAll('.alpha-free-gift-widget__nav-btn').forEach(n => {
          const label = n.classList.contains('alpha-free-gift-widget__nav-btn--prev') ? 'Cadeaux précédents' : 'Cadeaux suivants';
          if(n.getAttribute('aria-label') !== label) n.setAttribute('aria-label',label);
        });
      });
      if(widgets.length) document.documentElement.setAttribute('data-cbf-hue-design','true');
    };
    const observer = new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(refresh); } });
    observer.observe(main,{childList:true,subtree:true,characterData:true});
    refresh();
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();

// Keep gift links aligned with the HUE chooser, which is rendered asynchronously.
(() => {
  let observer, timeout, frame;
  const stop = () => {
    observer?.disconnect();
    clearTimeout(timeout);
    cancelAnimationFrame(frame);
  };
  const reveal = () => {
    if (document.documentElement.dataset.cbfHueEligible === 'false') return false;
    const active = document.querySelector('.alpha-widget[data-cbf-gift-step-hidden="false"] .alpha-cartPage-page');
    const target = active || [...document.querySelectorAll('.alpha-cartPage-page')]
      .find(node => node.getClientRects().length && getComputedStyle(node).display !== 'none') || document.querySelector('.cbf-gift-step-summary:not([hidden])');
    if (!target) return false;
    stop();
    cbfCenterGift(target, false);
    return true;
  };
  const seek = () => {
    stop();
    if (location.hash !== '#cbf-gift-selector') return;
    frame = requestAnimationFrame(() => {
      if (reveal()) return;
      observer = new MutationObserver(() => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(reveal);
      });
      observer.observe(document.documentElement, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'data-cbf-hue-eligible']
      });
      timeout = setTimeout(stop, 12000);
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname ||
        url.search !== location.search || url.hash !== '#cbf-gift-selector') return;
    event.preventDefault();
    if (location.hash !== url.hash) history.pushState(null, '', url.hash);
    seek();
  });
  window.addEventListener('hashchange', seek);
  window.addEventListener('pageshow', seek);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', seek, { once: true });
  else seek();
})();


(() => {
  if(!document.getElementById('cbf-cart-benefits'))return;
  const key='cbf-hue-gift-scroll-stage-v3';
  let previous=0,pending=0,frame=0,settleTimer;
  try{previous=Number(sessionStorage.getItem(key))||0;}catch(e){}
  const save=stage=>{previous=stage;try{sessionStorage.setItem(key,String(stage));}catch(e){}};
  const reveal=()=>{
    frame=0;
    if(!pending||document.documentElement.dataset.cbfHueEligible!=='true')return;
    const choices=[...document.querySelectorAll('.alpha-widget')].filter(n=>n.querySelector('.alpha-cartPage-page'));
    const root=choices.find(n=>n.dataset.cbfGiftStepHidden==='false')||choices.find(n=>!n.classList.contains('alpha-6ab6f343cb8b7624e2db31b4'));
    const target=root?.querySelector('.alpha-cartPage-page');
    if(!target||!target.getClientRects().length||getComputedStyle(target).display==='none')return;
    const stage=pending;pending=0;save(stage);
    requestAnimationFrame(()=>{
      if(previous!==stage||!target.isConnected)return;
      cbfCenterGift(target);
    });
  };
  const queue=()=>{if(!pending)return;clearTimeout(settleTimer);settleTimer=setTimeout(()=>{if(!frame)frame=requestAnimationFrame(reveal);},350);};
  document.addEventListener('cbf:cart-state',event=>{
    const cart=event.detail?.cart;if(event.detail?.error||!cart||cart.currency!=='EUR')return;
    const giftTotal=(cart.items||[]).filter(i=>i.properties?._cbf_gift||i.properties?._alpha_free_gift_mode).reduce((n,i)=>n+(Number(i.final_line_price)||0),0);
    const total=cart.total_price-giftTotal,stage=total>=9000?2:total>=5000?1:0;
    if(stage<previous){pending=0;save(stage);}
    else if(stage>previous){pending=stage;queue();}
    else if(pending&&pending!==stage)pending=0;
  });
  const main=document.querySelector('main');
  if(main)new MutationObserver(queue).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','data-cbf-gift-allowed']});
  new MutationObserver(queue).observe(document.documentElement,{attributes:true,attributeFilter:['data-cbf-hue-eligible']});
})();

(() => {
  const main=document.querySelector('main'),benefits=document.getElementById('cbf-cart-benefits');
  if(!main||!benefits)return;
  const style=document.createElement('style');
  style.textContent='[data-cbf-gift-step-hidden="true"]{display:none!important}.cbf-gift-step-summary{background:#3b2052;padding:18px;border:1px solid #ffffff40;border-radius:14px;color:#fff;margin:16px 0}.cbf-gift-step-summary h3{color:#b4f436;margin:0 0 12px;font-size:20px}.cbf-gift-step-summary p{margin:8px 0}.cbf-gift-step-summary button{background:transparent;color:#b4f436;text-decoration:underline;border:0;min-height:44px;padding:8px 0;font:inherit}.cbf-gift-step-summary [data-cbf-gift-row]{display:flex;gap:12px;align-items:center;justify-content:space-between}.cbf-gift-step-summary [data-cbf-gift-row] span{min-width:0;overflow-wrap:anywhere}.cbf-gift-step-summary[hidden]{display:none!important}';
  document.head.append(style);
  let stage=Number(benefits.dataset.total)>=9000?2:Number(benefits.dataset.total)>=5000?1:0;
  let editing=null,wanted=null,frame=0,lastView='',summary;
  try{const saved=sessionStorage.getItem('cbf-gift-edit-step');if(saved==='0'||saved==='1')editing=Number(saved);}catch(e){}
  const secondClass='alpha-6ab6f343cb8b7624e2db31b4';
  const roots=()=>[...document.querySelectorAll('.alpha-widget')].filter(n=>n.querySelector('.alpha-cartPage-page')).sort((a,b)=>Number(a.classList.contains(secondClass))-Number(b.classList.contains(secondClass)));
  const selected=root=>{
    const card=root?.querySelector('.alpha-free-gift-card:has(.alpha-free-gift-card__btn.is-claimed)');
    return card?{name:card.querySelector('.alpha-free-gift-card__title')?.textContent||'',variant:card.querySelector('select')?.value||''}:null;
  };
  const scrollTo=node=>cbfCenterGift(node);
  const replaceGift=async(step,button)=>{
    button.disabled=true;
    const root=window.Shopify?.routes?.root||'/';
    const offer=step===0?'6ab6ea45cb8b7624e2daa739':'6ab6f343cb8b7624e2db31b6';
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),12000);
    try{
      const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if(!response.ok)throw Error('cart');
      const cart=await response.json();
      const item=cart.items.find(i=>i.properties?._alpha_offer_id===offer&&i.properties?._alpha_free_gift_mode&&i.final_line_price===0);
      if(item){
        const changed=await fetch(root+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0}),signal:controller.signal});
        if(!changed.ok)throw Error('change');
        const result=await changed.json();if(result.errors||result.status>=400)throw Error('change');
      }
      try{sessionStorage.setItem('cbf-gift-edit-step',String(step));}catch(e){}
      location.hash='cbf-gift-selector';location.reload();
    }catch(e){
      button.disabled=false;
      let error=summary.querySelector('[role="alert"]');if(!error){error=document.createElement('p');error.setAttribute('role','alert');summary.append(error);}
      error.textContent='Le cadeau ne peut pas être modifié pour le moment. Réessayez.';
    }finally{clearTimeout(timeout);}
  };
  const refresh=()=>{
    frame=0;const widgets=roots();if(!widgets.length||widgets[0].classList.contains(secondClass))return;
    const gifts=widgets.map(selected);
    if(wanted&&gifts[wanted.step]?.variant===wanted.variant){editing=null;wanted=null;try{sessionStorage.removeItem('cbf-gift-edit-step');}catch(e){}}
    if(editing!==null&&editing>=stage){editing=null;wanted=null;}
    const active=stage?editing!==null?editing:!gifts[0]?0:stage===2&&!gifts[1]?1:null:null;
    widgets.forEach((root,i)=>{
      const hidden=!stage||i!==active;
      if(root.dataset.cbfGiftStepHidden!==String(hidden))root.dataset.cbfGiftStepHidden=String(hidden);
      const title=stage===2?(i===0?'Choisissez votre premier gramme offert — 1/2':'Choisissez votre deuxième gramme offert — 2/2'):'Choisissez votre gramme offert';
      if(root.dataset.cbfStepTitle!==title)root.dataset.cbfStepTitle=title;
      const heading=root.querySelector('.alpha-free-gift-widget__title');if(heading&&heading.textContent!==title)heading.textContent=title;
    });
    if(!summary){summary=document.createElement('section');summary.className='cbf-gift-step-summary';summary.setAttribute('aria-live','polite');}
    if(summary.parentElement!==widgets[0].parentElement)widgets[0].parentElement.append(summary);
    const done=stage>0&&gifts.slice(0,stage).filter(Boolean).length===stage;
    summary.hidden=!stage||(!done&&active===0);
    const view=JSON.stringify([stage,active,gifts.map(g=>g?.name||'')]);
    if(view===lastView)return;
    const previous=lastView;lastView=view;
    summary.replaceChildren();
    const heading=document.createElement('h3');heading.textContent=done?'Vos cadeaux sont ajoutés ✓':'Premier gramme ajouté ✓';summary.append(heading);
    gifts.slice(0,stage).forEach((gift,i)=>{if(!gift)return;const row=document.createElement('div');row.dataset.cbfGiftRow='';const name=document.createElement('span');name.textContent=(stage===2?(i+1)+'. ':'')+gift.name+' · 1 g offert';const button=document.createElement('button');button.type='button';button.textContent='Modifier';button.setAttribute('aria-label','Modifier '+(i===0?'le premier':'le deuxième')+' cadeau');button.addEventListener('click',()=>replaceGift(i,button));row.append(name,button);summary.append(row);});
    if(previous&&stage)scrollTo(active===null?summary:widgets[active]);
  };
  const queue=()=>{if(!frame)frame=requestAnimationFrame(refresh);};
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('.alpha-free-gift-card__btn');if(!button)return;
    const widgets=roots(),step=widgets.indexOf(button.closest('.alpha-widget'));if(step<0||step!==editing)return;
    wanted={step,variant:button.closest('.alpha-free-gift-card')?.querySelector('select')?.value};queue();
  },true);
  document.addEventListener('cbf:cart-state',event=>{
    const cart=event.detail?.cart;if(event.detail?.error||!cart||cart.currency!=='EUR')return;
    const gifts=(cart.items||[]).filter(i=>i.properties?._alpha_free_gift_mode||i.properties?._cbf_gift).reduce((n,i)=>n+(Number(i.final_line_price)||0),0);
    const total=cart.total_price-gifts;stage=total>=9000?2:total>=5000?1:0;queue();
  });
  new MutationObserver(queue).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['class','data-cbf-gift-allowed']});
  refresh();
})();
